// extracted by mini-css-extract-plugin
export default {"modesPage":"ModesPage_modesPage__jw47Z","titleContainer":"ModesPage_titleContainer__zh3sJ","pulse":"ModesPage_pulse__eFYMM","modesContainer":"ModesPage_modesContainer__8JgRJ"};